import head from 'lodash/head';
import { Facility } from './types';

export const normalizedFacilities = (facilities: {
  UrgentCares: Facility[];
  KidsCares: Facility[];
  EmergencyRooms: Facility[];
}) => {
  const instacares = facilities?.UrgentCares ?? [];
  const nearestInstacare = head(instacares);
  const nearestOpenInstacare = instacares.find(facility => facility.isCurrentlyOpen);

  const kidscares = facilities?.KidsCares ?? [];
  const nearestKidscare = head(kidscares);
  const nearestOpenKidscare = kidscares.find(facility => facility.isCurrentlyOpen);

  const emergencyRooms = facilities?.EmergencyRooms ?? [];
  const nearestEmergencyRoom = head(emergencyRooms);
  const nearestOpenEmergencyRoom = emergencyRooms.find(facility => facility.isCurrentlyOpen);

  return {
    instacares,
    kidscares,
    emergencyRooms,
    nearestInstacare,
    nearestKidscare,
    nearestEmergencyRoom,
    nearestOpenInstacare,
    nearestOpenKidscare,
    nearestOpenEmergencyRoom
  };
};
